import axiosClient from "./axiosClient";
import axiosClientAdmin from "./axiosClientAdmin";
const authenticationService = {
    login: async (params) => {
        const url = `/core-manager/authentication/sso/web/login_direct`;
        const response = await axiosClient.post(url, params);
        return response.data;
    },
    loginAdmin: async (params) => {
        const url = `/core-manager/sso/admin/login`;
        const response = await axiosClient.post(url, params);
        return response.data;
    },
    getListUser: async () => {
        const url = `/core-manager/sso/users/list_user`;
        const response = await axiosClientAdmin.get(url);
        return response.data;
    },
    getListUserByName: async (name, role) => {
        const params = { search: name, role: role };
        const url = `/core-manager/sso/users/search`;
        const response = await axiosClientAdmin.get(url, { params: params });
        return response.data;
    },
    getListRole: async () => {
        const url = `/core-manager/sso/roles`;
        const response = await axiosClientAdmin.get(url);
        return response.data;
    },
    getListRoleAlina: async () => {
        const url = `/core-manager/sso/role/list-role`;
        const response = await axiosClientAdmin.get(url);
        return response.data;
    },
    getListRoleAlinaByName: async (name) => {
        const url = `/core-manager/sso/role/search?name=${name}`;
        const response = await axiosClientAdmin.get(url);
        return response.data;
    },
    postRoleAlina: async (params) => {
        const url = `/core-manager/sso/roles`;
        const response = await axiosClientAdmin.post(url, params);
        return response.data;
    },
    updateRoleAlina: async (params) => {
        const url = `/core-manager/sso/roles`;
        const response = await axiosClientAdmin.put(url, params);
        return response.data;
    },
    addFuncToRoleAlina: async (params) => {
        const url = `/core-manager/sso/chuc-nang-role`;
        const response = await axiosClientAdmin.post(url, params);
        return response.data;
    },
    addMenuToRoleAlina: async (params) => {
        const url = `/core-manager/sso/role-menu`;
        const response = await axiosClientAdmin.post(url, params);
        return response.data;
    },
    addTabToRoleAlina: async (params) => {
        const url = `/core-manager/sso/role-tab`;
        const response = await axiosClientAdmin.post(url, params);
        return response.data;
    },
    updateTabToRoleAlina: async (params) => {
        const url = `/core-manager/sso/role-tab`;
        const response = await axiosClientAdmin.put(url, params);
        return response.data;
    },
    deleteRoleAlina: async (id) => {
        const url = `/core-manager/sso/roles?id=${id}`;
        const response = await axiosClientAdmin.delete(url);
        return response.data;
    },
    getListFuncByRoleAlina: async (idRole) => {
        const url = `/core-manager/sso/chuc-nang-role/role-id?roleId=${idRole}`;
        const response = await axiosClientAdmin.get(url);
        return response.data;
    },
    getListMenuByRoleAlina: async (idRole) => {
        const url = `/core-manager/sso/role-menu/role-id?roleId=${idRole}`;
        const response = await axiosClientAdmin.get(url);
        return response.data;
    },
    getListTabByRoleAlina: async (idRole) => {
        const url = `/core-manager/sso/role-tab/role-id?roleId=${idRole}`;
        const response = await axiosClientAdmin.get(url);
        return response.data;
    },
    getListBranch: async () => {
        const url = `/core-manager/sso/branch/list-branch`;
        const response = await axiosClientAdmin.get(url);
        return response.data;
    },
    postBranch: async (params) => {
        const url = `/core-manager/sso/branch`;
        const response = await axiosClientAdmin.post(url, params);
        return response.data;
    },
    updateBranch: async (params) => {
        const url = `/core-manager/sso/branch`;
        const response = await axiosClientAdmin.put(url, params);
        return response.data;
    },
    deleteBranch: async (id) => {
        const url = `/core-manager/sso/branch?id=${id}`;
        const response = await axiosClientAdmin.delete(url);
        return response.data;
    },
    getDetailUser: async (id) => {
        const url = `/core-manager/sso/users/detail_user?id=${id}`;
        const response = await axiosClientAdmin.get(url);
        return response.data;
    },
    postUser: async (params) => {
        const url = `/core-manager/sso/users`;
        const response = await axiosClientAdmin.post(url, params);
        return response.data;
    },
    updateUser: async (params) => {
        const url = `/core-manager/sso/users?id=${params?.dto?.id}`;
        const response = await axiosClientAdmin.put(url, params);
        return response.data;
    },
    postRole: async (idUser, role) => {
        const url = `/core-manager/sso/users/role_mappings?idUser=${idUser}`;
        const response = await axiosClientAdmin.post(url, role);
        return response.data;
    },
    removeRole: async (idUser, role) => {
        const url = `/core-manager/sso/users/role_mappings?idUser=${idUser}`;
        const response = await axiosClientAdmin.delete(url, { data: role });
        return response.data;
    },
    getListFunc: async () => {
        const url = `/core-manager/sso/chuc-nang/get-all`;
        const response = await axiosClientAdmin.get(url);
        return response.data;
    },
    getListFuncByName: async (name) => {
        const url = `/core-manager/sso/chuc-nang/name?name=${name}`;
        const response = await axiosClientAdmin.get(url);
        return response.data;
    },
    postFunc: async (params) => {
        const url = `/core-manager/sso/chuc-nang`;
        const response = await axiosClientAdmin.post(url, params);
        return response.data;
    },
    updateFunc: async (params) => {
        const url = `/core-manager/sso/chuc-nang`;
        const response = await axiosClientAdmin.put(url, params);
        return response.data;
    },
    deleteFunc: async (id) => {
        const url = `/core-manager/sso/chuc-nang?id=${id}`;
        const response = await axiosClientAdmin.delete(url);
        return response.data;
    },
    getListApiByFunc: async (idFunc) => {
        const url = `/core-manager/sso/chuc-nang-api/chuc-nang-id?chucNangId=${idFunc}`;
        const response = await axiosClientAdmin.get(url);
        return response.data;
    },
    getListApi: async () => {
        const url = `/core-manager/sso/api/get-all`;
        const response = await axiosClientAdmin.get(url);
        return response.data;
    },
    getListApiByName: async (name) => {
        const url = `/core-manager/sso/api/search?name=${name}`;
        const response = await axiosClientAdmin.get(url);
        return response.data;
    },
    addApiToFunc: async (params) => {
        const url = `/core-manager/sso/chuc-nang-api`;
        const response = await axiosClientAdmin.post(url, params);
        return response.data;
    },
    deleteApiFromFunc: async (idFunc, params) => {
        const url = `/core-manager/sso/chuc-nang-api?id=${idFunc}`;
        const response = await axiosClientAdmin.delete(url, params);
        return response.data;
    },
    deleteFuncFromRole: async (id) => {
        const url = `/core-manager/sso/chuc-nang-role?id=${id}`;
        const response = await axiosClientAdmin.delete(url);
        return response.data;
    },
    deleteMenuFromRole: async (id) => {
        const url = `/core-manager/sso/role-menu?id=${id}`;
        const response = await axiosClientAdmin.delete(url);
        return response.data;
    },
    resetPass: async (idUser, params) => {
        const url = `/core-manager/sso/users/reset_password?id=${idUser}`;
        const response = await axiosClientAdmin.put(url, params);
        return response.data;
    },
    updateRoleSSO: async () => {
        const url = `/gateway-server/update`;
        const response = await axiosClient.get(url);
        return response.data;
    },


};

export default authenticationService;
